// src/packages/chubb/travel/chubb_travel_international/ChubbTravelDetails.jsx
import React, { useState } from "react";
import "./chubb_travel.css";

/**
 * Chubb Travel — International (Single Trip + Annual Trip)
 * Zero-index safe: ไม่มีตัวแปรชื่อ 'index' ใน JSX และทุก .map ใช้คีย์จากข้อมูลจริง
 */
export default function ChubbTravelDetails({ onQuote }) {
  const [showAllDays, setShowAllDays] = useState(false);

  // ====== ตารางผลประโยชน์หลัก (ย่อ) ======
  const plans = [
    { key: "asia_easy1", region: "Asia",      name: "Easy 1",     medical: "จ่ายตามจริงสูงสุด", evac: "จ่ายตามจริงสูงสุด", repat: "จ่ายตามจริงสูงสุด", baggage: "จำกัด/ชิ้น 5,000 • Excess 1,000", tripCancel: "จ่ายตามจริง (ตามเงื่อนไข)", delay: "20% ของทุนทุก ๆ 6 ชม.", liability: "จ่ายตามจริงสูงสุด" },
    { key: "asia_easy2", region: "Asia",      name: "Easy 2",     medical: "จ่ายตามจริงสูงสุด", evac: "จ่ายตามจริงสูงสุด", repat: "จ่ายตามจริงสูงสุด", baggage: "จำกัด/ชิ้น 5,000 • Excess 1,000", tripCancel: "จ่ายตามจริง (ตามเงื่อนไข)", delay: "20% ของทุนทุก ๆ 6 ชม.", liability: "จ่ายตามจริงสูงสุด" },
    { key: "asia_easy3", region: "Asia",      name: "Easy 3",     medical: "จ่ายตามจริงสูงสุด", evac: "จ่ายตามจริงสูงสุด", repat: "จ่ายตามจริงสูงสุด", baggage: "Excess 1,000",                 tripCancel: "จ่ายตามจริง (ตามเงื่อนไข)", delay: "20% ของทุนทุก ๆ 6 ชม.", liability: "จ่ายตามจริงสูงสุด" },
    { key: "ww_easy1",   region: "Worldwide", name: "Easy 1",     medical: "จ่ายตามจริงสูงสุด", evac: "จ่ายตามจริงสูงสุด", repat: "จ่ายตามจริงสูงสุด", baggage: "จำกัด/ชิ้น 5,000 • Excess 1,000", tripCancel: "จ่ายตามจริง (ตามเงื่อนไข)", delay: "20% ของทุนทุก ๆ 6 ชม.", liability: "จ่ายตามจริงสูงสุด" },
    { key: "visa_plus",  region: "Worldwide", name: "Easy VISA Plus", medical: "จ่ายตามจริงสูงสุด", evac: "จ่ายตามจริงสูงสุด", repat: "จ่ายตามจริงสูงสุด", baggage: "Excess 1,000", tripCancel: "จ่ายตามจริง (ตามเงื่อนไข)", delay: "20% ของทุนทุก ๆ 6 ชม.", liability: "จ่ายตามจริงสูงสุด" },
    { key: "visa",       region: "Worldwide", name: "Easy VISA",  medical: "จ่ายตามจริงสูงสุด", evac: "จ่ายตามจริงสูงสุด", repat: "จ่ายตามจริงสูงสุด", baggage: "Excess 1,000",                 tripCancel: "จ่ายตามจริง (ตามเงื่อนไข)", delay: "20% ของทุนทุก ๆ 6 ชม.", liability: "จ่ายตามจริงสูงสุด" },
  ];

  // ====== ราคาแบบรายเที่ยว (Single Trip) — คีย์จากภาพตารางที่ส่งมา ======
  // เติมต่อได้ง่าย ๆ: ใส่ {days: 11, ...} จนถึงช่วง 179–180 และช่วงแบบเป็นช่วง ใช้ label กำกับ
  const singleTripRowsAll = [
    // days 1–10 (จากภาพ)
    { key: "d1",  label: "1",  days: 1,  e1_asia:  890, e1_world: 1060, e2_asia:  655, e2_world:  875, e3_asia:  440, e3_world:  570, visa_plus_asia: 250, visa_plus_world: 300, visa_asia: 190, visa_world: 255 },
    { key: "d2",  label: "2",  days: 2,  e1_asia:  900, e1_world: 1215, e2_asia:  665, e2_world:  945, e3_asia:  450, e3_world:  615, visa_plus_asia: 270, visa_plus_world: 315, visa_asia: 195, visa_world: 280 },
    { key: "d3",  label: "3",  days: 3,  e1_asia:  910, e1_world: 1225, e2_asia:  675, e2_world:  960, e3_asia:  455, e3_world:  585, visa_plus_asia: 280, visa_plus_world: 320, visa_asia: 200, visa_world: 265 },
    { key: "d4",  label: "4",  days: 4,  e1_asia: 1045, e1_world: 1430, e2_asia:  765, e2_world: 1040, e3_asia:  505, e3_world:  670, visa_plus_asia: 320, visa_plus_world: 380, visa_asia: 205, visa_world: 305 },
    { key: "d5",  label: "5",  days: 5,  e1_asia: 1060, e1_world: 1445, e2_asia:  765, e2_world: 1060, e3_asia:  515, e3_world:  680, visa_plus_asia: 335, visa_plus_world: 395, visa_asia: 215, visa_world: 310 },
    { key: "d6",  label: "6",  days: 6,  e1_asia: 1070, e1_world: 1465, e2_asia:  785, e2_world: 1080, e3_asia:  515, e3_world:  685, visa_plus_asia: 360, visa_plus_world: 400, visa_asia: 220, visa_world: 315 },
    { key: "d7",  label: "7",  days: 7,  e1_asia: 1350, e1_world: 1665, e2_asia:  985, e2_world: 1210, e3_asia:  645, e3_world:  775, visa_plus_asia: 420, visa_plus_world: 460, visa_asia: 265, visa_world: 350 },
    { key: "d8",  label: "8",  days: 8,  e1_asia: 1335, e1_world: 1685, e2_asia: 1005, e2_world: 1210, e3_asia:  665, e3_world:  775, visa_plus_asia: 460, visa_plus_world: 535, visa_asia: 295, visa_world: 350 },
    { key: "d9",  label: "9",  days: 9,  e1_asia: 1365, e1_world: 1700, e2_asia: 1005, e2_world: 1230, e3_asia:  725, e3_world:  835, visa_plus_asia: 495, visa_plus_world: 580, visa_asia: 305, visa_world: 360 },
    { key: "d10", label: "10", days: 10, e1_asia: 1385, e1_world: 1770, e2_asia: 1005, e2_world: 1250, e3_asia:  765, e3_world:  895, visa_plus_asia: 530, visa_plus_world: 650, visa_asia: 315, visa_world: 460 },

    // ===== สเกลตันแถวถัดไป (กรอกต่อได้ทันทีตามภาพตาราง) =====
    { key: "d11",  label: "11",  days: 11 },
    { key: "d12",  label: "12",  days: 12 },
    { key: "d13",  label: "13",  days: 13 },
    { key: "d14",  label: "14",  days: 14 },
    { key: "d15",  label: "15",  days: 15 },
    { key: "d16",  label: "16",  days: 16 },
    { key: "d17",  label: "17",  days: 17 },
    { key: "d18",  label: "18",  days: 18 },
    { key: "d19",  label: "19",  days: 19 },
    { key: "d20",  label: "20",  days: 20 },
    { key: "d21",  label: "21",  days: 21 },
    { key: "d22",  label: "22",  days: 22 },
    { key: "d23",  label: "23",  days: 23 },
    { key: "d24",  label: "24",  days: 24 },
    { key: "d25",  label: "25",  days: 25 },
    { key: "d26",  label: "26",  days: 26 },
    { key: "d27",  label: "27",  days: 27 },
    { key: "d28",  label: "28",  days: 28 },
    { key: "d29",  label: "29",  days: 29 },
    { key: "d30",  label: "30",  days: 30 },
    { key: "d31",  label: "31",  days: 31 },
    { key: "d32_38", label: "32–38", range: [32,38] },
    { key: "d39_45", label: "39–45", range: [39,45] },
    { key: "d46_52", label: "46–52", range: [46,52] },
    { key: "d53_59", label: "53–59", range: [53,59] },
    { key: "d60_66", label: "60–66", range: [60,66] },
    { key: "d67_73", label: "67–73", range: [67,73] },
    { key: "d74_80", label: "74–80", range: [74,80] },
    { key: "d81_87", label: "81–87", range: [81,87] },
    { key: "d88_94", label: "88–94", range: [88,94] },
    { key: "d95_101", label: "95–101", range: [95,101] },
    { key: "d102_108", label: "102–108", range: [102,108] },
    { key: "d109_115", label: "109–115", range: [109,115] },
    { key: "d116_122", label: "116–122", range: [116,122] },
    { key: "d123_129", label: "123–129", range: [123,129] },
    { key: "d130_136", label: "130–136", range: [130,136] },
    { key: "d137_143", label: "137–143", range: [137,143] },
    { key: "d144_150", label: "144–150", range: [144,150] },
    { key: "d151_157", label: "151–157", range: [151,157] },
    { key: "d158_164", label: "158–164", range: [158,164] },
    { key: "d165_171", label: "165–171", range: [165,171] },
    { key: "d172_178", label: "172–178", range: [172,178] },
    { key: "d179_180", label: "179–180", range: [179,180] },
  ];

  const singleTripRows = showAllDays ? singleTripRowsAll : singleTripRowsAll.slice(0, 10);

  // ====== ราคาแบบรายปี (Annual Trip) — จากภาพตารางที่ส่งมา ======
  const annualTripRows = [
    { key: "a120", label: "เดินทางสูงสุด 120 วัน/ทริป", easy1:  8200, easy2:  5800, easy3:  3750 },
    { key: "a180", label: "เดินทางสูงสุด 180 วัน/ทริป", easy1: 23285, easy2: 16348, easy3:  9920 },
    { key: "a240", label: "เดินทางสูงสุด 240 วัน/ทริป", easy1: 31385, easy2: 22198, easy3: 13520 },
    { key: "a365", label: "เดินทางสูงสุด 365 วัน/ทริป", easy1: 57785, easy2: 41510, easy3: 25295 },
  ];

  return (
    <div className="pkg-detail chubb-travel">
      <h2>Chubb Travel Insurance – International (Single Trip / Annual Trip)</h2>
      <p className="pkg-note">
        สรุปราคาและผลประโยชน์หลักตามเอกสาร Travel Easy (อัปเดตปี 2023)
      </p>

      {/* ตารางผลประโยชน์หลัก */}
      <table className="pkg-table">
        <thead>
          <tr>
            <th>ภูมิภาค</th>
            <th>แผน</th>
            <th>ค่ารักษาพยาบาล</th>
            <th>อพยพ/ส่งกลับ</th>
            <th>ส่งศพกลับ</th>
            <th>กระเป๋า & ทรัพย์สิน</th>
            <th>ยกเลิก/เลื่อนทริป</th>
            <th>เที่ยวบินล่าช้า</th>
            <th>ความรับผิดต่อบุคคลภายนอก</th>
          </tr>
        </thead>
        <tbody>
          {plans.map((p) => (
            <tr key={`${p.region}-${p.name}`}>
              <td>{p.region}</td>
              <td>{p.name}</td>
              <td>{p.medical}</td>
              <td>{p.evac}</td>
              <td>{p.repat}</td>
              <td>{p.baggage}</td>
              <td>{p.tripCancel}</td>
              <td>{p.delay}</td>
              <td>{p.liability}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* ตารางราคา Single Trip */}
      <h3 className="pkg-section">เบี้ยรายเที่ยว (Single Trip) — บาท/วัน</h3>
      <div className="pg-scroll-x">
        <table className="pkg-table">
          <thead>
            <tr>
              <th>จำนวนวัน</th>
              <th colSpan={2}>Easy 1</th>
              <th colSpan={2}>Easy 2</th>
              <th colSpan={2}>Easy 3</th>
              <th colSpan={2}>Easy VISA Plus</th>
              <th colSpan={2}>Easy VISA</th>
            </tr>
            <tr>
              <th></th>
              <th>Asia</th><th>Worldwide</th>
              <th>Asia</th><th>Worldwide</th>
              <th>Asia</th><th>Worldwide</th>
              <th>Asia</th><th>Worldwide</th>
              <th>Asia</th><th>Worldwide</th>
            </tr>
          </thead>
          <tbody>
            {singleTripRows.map((r) => (
              <tr key={`st-${r.key}`}>
                <td>{r.label}</td>
                <td>{r.e1_asia  ?? "—"}</td><td>{r.e1_world ?? "—"}</td>
                <td>{r.e2_asia  ?? "—"}</td><td>{r.e2_world ?? "—"}</td>
                <td>{r.e3_asia  ?? "—"}</td><td>{r.e3_world ?? "—"}</td>
                <td>{r.visa_plus_asia ?? "—"}</td><td>{r.visa_plus_world ?? "—"}</td>
                <td>{r.visa_asia ?? "—"}</td><td>{r.visa_world ?? "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="pkg-foot">
        <button className="pkg-small-btn" onClick={() => setShowAllDays((v) => !v)}>
          {showAllDays ? "แสดงเฉพาะ 1–10 วัน" : "แสดงทุกช่วงวัน (32–180 วัน)"}
        </button>
      </div>

      {/* ตารางราคา Annual Trip */}
      <h3 className="pkg-section">เบี้ยรายปี (Annual Trip)</h3>
      <table className="pkg-table">
        <thead>
          <tr>
            <th>เงื่อนไขทริปสูงสุด/ครั้ง</th>
            <th>Easy 1</th>
            <th>Easy 2</th>
            <th>Easy 3</th>
          </tr>
        </thead>
        <tbody>
          {annualTripRows.map((r) => (
            <tr key={`an-${r.key}`}>
              <td className="pkg-left">{r.label}</td>
              <td>{r.easy1.toLocaleString()}</td>
              <td>{r.easy2.toLocaleString()}</td>
              <td>{r.easy3.toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="pkg-foot">
        <p className="pkg-note">* ค่าเบี้ยรวมอากรแสตมป์แล้ว ตามเอกสารบริษัท</p>
        <button className="pkg-quote-btn" onClick={onQuote} aria-label="ขอใบเสนอราคา Chubb Travel">
          ขอใบเสนอราคา
        </button>
      </div>
    </div>
  );
}
